/*
 * File: calendar.service.ts
 * Project: a-a
 * File Created: Monday, 1st September 2025 10:39:36 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 18th September 2025 6:22:27 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';
import { ClientActivityQueryParams, ClientTaskQueryParams } from '../model/client.model';
// import { ActivityQueryParams, TaskQueryParams } from '../model/dashboard.model';

import { ApiConstants } from './api-constants';
export class CalendarService {
  static getGoogleEvents = async (query: any) => {
    return await (
      await axios.get(
        ApiConstants.CALENDAR_API.GOOGLE_CALENDAR.URL() +
          ApiConstants.CALENDAR_API.GOOGLE_CALENDAR.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getZoomEvents = async (query: any) => {
    return await (
      await axios.get(
        ApiConstants.CALENDAR_API.ZOOM_CALENDAR.URL(),
        // +ApiConstants.CALENDAR_API.ZOOM_CALENDAR.QUERY_PARAMS(query),
      )
    ).data;
  };
}
